<!-- <div style="height: 30px;"></div>-->
<mat-accordion >
  <!-- #enddocregion basic-panel -->
  <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" [expanded]="panelOpenState">
    <mat-expansion-panel-header>
      <mat-panel-description style=" margin-top: 10px!important;" >
        {{panelOpenState ? 'Hide Parameters' : 'Show Parameters'}}
      </mat-panel-description>
    </mat-expansion-panel-header>
    <form>
      <table cellspacing="0">
        <tr>
          <td>
            <mat-form-field>
              <mat-label>Node Width</mat-label>
              <input type="number" matInput min="50" max="400" required [formControl]="nodeWidthFormControl"
                [(ngModel)]="viewModel.nodeWidth" (input)="onSettingChange()">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <mat-label>Node Height Ratio Per</mat-label>
              <input type="number" matInput min="35" max="55" required [formControl]="nodeHeightRatioFormControl"
                [(ngModel)]="viewModel.nodeHeightRatio_Per" (input)="onSettingChange()">
              <span matSuffix>%</span>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <mat-label> Gear Size</mat-label>
              <input type="number" matInput min="1" max="200" required [formControl]="nodeGearSize_PerFormControl"
                [(ngModel)]="viewModel.nodeGearSize_Per" (input)="onSettingChange()">
              <span matSuffix>%</span>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <mat-label> Data Writer Size</mat-label>
              <input type="number" matInput min="1" max="200" required [formControl]="DatawriterSize_Per_FormControl"
                [(ngModel)]="viewModel.dataWriterSize_Per" (input)="onSettingChange()">
              <span matSuffix>%</span>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <mat-label>Padding X</mat-label>
              <input type="number" matInput min="1" max="500" required [formControl]="nodePadding_XFormControl"
                [(ngModel)]="viewModel.nodePadding_X" (input)="onSettingChange()">
            </mat-form-field></td>
          <td>
            <mat-form-field>
              <mat-label>Padding Y</mat-label>
              <input type="number" matInput min="1" max="500" required [formControl]="nodePadding_YFormControl"
                [(ngModel)]="viewModel.nodePadding_Y" (input)="onSettingChange()">
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>
            <mat-form-field>
              <mat-label>Border Weight</mat-label>
              <input type="number" matInput min="1" max="5" required [formControl]="nodeBorderWeightFormControl"
                [(ngModel)]="viewModel.nodeBorderWeight" (input)="onSettingChange()">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <mat-label>Title Font Size</mat-label>
              <input type="number" matInput min="10" max="20" required [formControl]="nodeFontSizeTitlePerFormControl"
                [(ngModel)]="viewModel.nodeFontSizeTitlePer" (input)="onSettingChange()">
              <span matSuffix>%</span>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <mat-label> Subtitle Font Size</mat-label>
              <input type="number" matInput min="8" max="20" required
                [formControl]="nodeFontSizeSubtitlePerFormControl" [(ngModel)]="viewModel.nodeFontSizeSubtitlePer"
                (input)="onSettingChange()">
              <span matSuffix>%</span>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <mat-label>Node ID Font Size</mat-label>
              <input type="number" matInput min="10" max="20" required
                [formControl]="nodeFontSizeFarmTypePerFormControl" [(ngModel)]="viewModel.nodeFontSizeFarmTypePer"
                (input)="onSettingChange()">
              <span matSuffix>%</span>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <mat-label> Status Font Size</mat-label>
              <input type="number" matInput min="10" max="20" required [formControl]="nodeFontSizeStatusPerFormControl"
                [(ngModel)]="viewModel.nodeFontSizeStatusPer" (input)="onSettingChange()">
              <span matSuffix>%</span>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <mat-label> Menu Font Size</mat-label>
              <input type="number" matInput min="10" max="20" required [formControl]="nodeMenuFontSizePerFormControl"
                [(ngModel)]="viewModel.nodeMenuFontSizePer" (input)="onSettingChange()">
              <span matSuffix>%</span>
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>
            <mat-form-field>
              <mat-label>Title Pad X</mat-label>
              <input type="number" matInput min="0" max="10" required [formControl]="titlePadXControl"
                [(ngModel)]="viewModel.titlePadXPer" (input)="onSettingChange()">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <mat-label>Title Pad Y</mat-label>
              <input type="number" matInput min="0" max="10" required [formControl]="titlePadYControl"
                [(ngModel)]="viewModel.titlePadYPer" (input)="onSettingChange()">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <mat-label> Subtitle Pad X</mat-label>
              <input type="number" matInput min="0" max="10" required
                [formControl]="SubTitlePadXControl" [(ngModel)]="viewModel.subTitlePadXPer"
                (input)="onSettingChange()">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <mat-label>Subtitle Pad Y</mat-label>
              <input type="number" matInput min="0" max="10" required
                [formControl]="SubTitlePadYControl" [(ngModel)]="viewModel.subTitlePadYPer"
                (input)="onSettingChange()">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <mat-label> NodeID Pad X</mat-label>
              <input type="number" matInput min="0" max="10" required
                [formControl]="NodeIDPadXControl" [(ngModel)]="viewModel.nodeIDPadXPer"
                (input)="onSettingChange()">
            </mat-form-field> 
          </td>
          <td> 
            <mat-form-field>
              <mat-label> NodeID Pad Y</mat-label>
              <input type="number" matInput min="0" max="10" required
                [formControl]="NodeIDPadYControl" [(ngModel)]="viewModel.nodeIDPadYPer"
                (input)="onSettingChange()">
            </mat-form-field> 
          </td>
        </tr>
    </table>
    </form>

    <div class="example-button-row">
        <button style="color: #1ea9d3" class="save-btn" mat-button (click)="saveRefineryConfigNoPrompt()">
        <mat-icon
      class="primary-color-icon "
      style="margin-right: 1px; font-size: 22px; height: 22px; width: 22px; line-height: 22px; vertical-align: middle;"
    >save</mat-icon>SAVE
        </button>
      <button style="color: #e07b39; margin-left: 5px;" class="save-btn" mat-button (click)="resetParameters()">
        <mat-icon
          style="margin-right: 1px; font-size: 22px; height: 22px; width: 22px; line-height: 22px; vertical-align: middle;"
        >restart_alt</mat-icon>RESET
      </button>
      <button mat-flat-button style="margin-bottom: 10px;margin-top: 10px;margin-left: 5px;" color="primary" title="Add New Refinery"
        (click)="NewRefineryConfig(ingestMenuTrigger)">
        <mat-icon style="margin-right:0px;">note_add</mat-icon>
        <span style="margin-left:5px;">New Refinery</span>
      </button>
    </div>
    <div class="content">
      <mat-card>
        <!-- <mat-card-header>
              <mat-icon class="card-header-icon" mat-card-avatar>builds</mat-icon>
              <mat-card-title>Refinery</mat-card-title>
              <mat-card-subtitle>List of data Refinery</mat-card-subtitle>
          </mat-card-header> -->
        <!-- <mat-card-actions style="margin-left: 0px; margin-bottom: 10px;">
              <button mat-flat-button style="margin-bottom: 10px;" color="primary" title="Add New Refinery">
                  <mat-icon>note_add</mat-icon>
                  <span style="margin-left: 10px;">New Refinery</span>
              </button>
          </mat-card-actions> -->
        <mat-card-content>
          <h1 *ngIf="!hasConfigs || hasError" class="center" style="color: lightgray">{{ hasError ? 'Failed to Load
            Refineries' : 'No Refineries Found' }}</h1>
    
          <!-- <table *ngIf="hasConfigs" mat-table [dataSource]="mappingConfigs" class="mat-elevation-z8" style="width: 80%;">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef> Id </th>
              <td mat-cell *matCellDef="let config"> {{config.id}} </td>
            </ng-container>
    
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef> Name </th>
              <td mat-cell *matCellDef="let config"> {{config.name}} </td>
            </ng-container>
            <ng-container matColumnDef="owner">
              <th mat-header-cell *matHeaderCellDef> Owner </th>
              <td mat-cell *matCellDef="let config"> {{config.owner}} </td>
            </ng-container>
            <ng-container matColumnDef="createdDateTime">
              <th mat-header-cell *matHeaderCellDef> Created Date </th>
              <td mat-cell *matCellDef="let config"> {{datePipe.transform(config.createdDateTime, 'MM/dd/yyyy h:mm:ss a')}}
              </td>
            </ng-container>
    
            <ng-container matColumnDef="modifiedDateTime">
              <th mat-header-cell *matHeaderCellDef> Modified Date </th>
              <td mat-cell *matCellDef="let config"> {{datePipe.transform(config.modifiedDateTime, 'MM/dd/yyyy h:mm:ss a')}}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> Status </th>
              <td mat-cell *matCellDef="let config"> {{RefineryStatusUtil.toString(config.status)}} </td>
            </ng-container>
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef> Description </th>
              <td mat-cell *matCellDef="let config"> {{config.description}} </td>
            </ng-container>
            <ng-container matColumnDef="shared">
      <th mat-header-cell *matHeaderCellDef> Shared </th>
      <td mat-cell *matCellDef="let config">
        <span matTooltipClass="custom-mat-tooltip" style="margin-right: 10px;" >
          <span matTooltipClass="custom-mat-tooltip" style="margin-right: 10px;">
      <mat-slide-toggle color="primary" 
                       labelPosition="before" 
                       [(ngModel)]="config.shared" 
                       (click)="$event.stopPropagation();"
                       (change)="onToggleChange($event.checked, config)
                       [disabled]="config.owner !== currentUser"
                       >
      </mat-slide-toggle>
    </span>
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="public">
      <th mat-header-cell *matHeaderCellDef> Public </th>
      <td mat-cell *matCellDef="let config">
        <span matTooltipClass="custom-mat-tooltip" style="margin-right: 10px;" >
          <span matTooltipClass="custom-mat-tooltip" style="margin-right: 10px;">
            <mat-slide-toggle color="primary" 
                       labelPosition="before" 
                       [(ngModel)]="config.publicShared" 
                       (click)="$event.stopPropagation();"
                       (change)="onPublicToggleChange($event.checked, config)"
                       [disabled]="config.owner !== currentUser">
                       
      </mat-slide-toggle>
    </span>
        </span>
      </td>
    </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef> Actions </th>
              <td mat-cell *matCellDef="let config">
                <button mat-icon-button (click)="$event.stopPropagation(); duplicateConfig(config)">
                  <mat-icon color="primary" class="icon" matTooltip="Duplicate Refinery">content_copy</mat-icon>
                </button>
                <button mat-icon-button (click)="$event.stopPropagation(); deleteConfig(config)"
                [disabled]="config.owner !== currentUser">
                  <mat-icon [ngClass]="config.owner !== currentUser ? 'grey-icon' : 'red-icon'" matTooltip="Delete Refinery">delete_forever</mat-icon>
                </button>
              </td>
            </ng-container>
    
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row style="cursor: pointer;" *matRowDef="let config; columns: displayedColumns;"
              (click)="loadConfigDetail(config)"></tr>
          </table> -->
        </mat-card-content>
      </mat-card>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<mat-accordion>
  <mat-expansion-panel (opened)="refineryPreviewPanelOpenState = true" (closed)="refineryPreviewPanelOpenState = false" [expanded]="refineryPreviewPanelOpenState">
    <mat-expansion-panel-header>
      <!-- <mat-panel-title>
        <p  > Currently I am {{refineryPreviewPanelOpenState ? 'open' : 'closed'}} </p>
      </mat-panel-title> -->
      <mat-panel-description (click)="onDescriptionClick($event)">
        <p [ngStyle]="{'color':dataPreviewNodeColor}"  style="margin: 0px !important;">{{ dataPreviewNodeID }}</p> 
      </mat-panel-description>
    </mat-expansion-panel-header>
    
    <mat-tab-group #tabGroup animationDuration="300ms" (selectedTabChange)="onTabClick($event)">
      <mat-tab label="Input ({{inputColumnCount}})" *ngIf="previewInputTableLabel.length!=0">
          <app-preview-table [delegate]="this" #inputDataFarmPreviewTable [hideRefresh]="true"
              [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="Input"></app-preview-table>
      </mat-tab>     
      <mat-tab *ngFor="let tab of joinerPreviewTabs">
          <ng-template mat-tab-label>
              <span [ngStyle]="{'color': tab.color}">{{tab.label}}</span>
          </ng-template>
          <div style="position: relative;">
              <app-preview-table [delegate]="this" #joinerInputPreviewTable [hideRefresh]="true"
                  [hideOptions]="true" [viewModel]="previewDataViewModel" [previewType]="tab.nodeName"></app-preview-table>
          </div>
      </mat-tab>
      <mat-tab label="Output ({{outputColumnCount}})">
          <app-preview-table [delegate]="this" #outputDataFarmPreviewTable [hideRefresh]="true"
              [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="Output"></app-preview-table>
      </mat-tab>
      <mat-tab label="Summary (Input)" *ngIf="joinerPreviewTabs.length==0">
          <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryinput" #menuTriggerInput="matMenuTrigger"  style="margin-top: 3px;margin-left: 5px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerInput,'Input')">Summary Fields</button>
          <span>{{ totalSummaryRowsInput }}</span>
          <mat-menu #menusummaryinput="matMenu" yPosition="below" style="margin-top: 2% !important;">
              <app-select-filter-option [values]="selectValuesInput" source="Input" [emptyColumns]="selectEmptyColumnsInput" [selectedColumns]="selectFilterValuesInput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
          </mat-menu>
          <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableInput [hideRefresh]="true" previewType="Summary" 
              [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
      </mat-tab>
      <mat-tab *ngFor="let tab of joinerPreviewTabs; let i = index">
          <ng-template mat-tab-label>
              <span [ngStyle]="{'color': tab.color}">Summary ({{tab.nodeName}})</span>
          </ng-template>
          <button mat-raised-button color="primary" [matMenuTriggerFor]="joinerSummaryMenu" #joinerSummaryTrigger="matMenuTrigger" style="margin-top: 3px;margin-left: 5px;margin-right: 50px;" (click)="showSelectFilter(joinerSummaryTrigger, tab.nodeName)">Summary Fields</button>
          <span>{{ joinerTotalSummaryRows[i] }}</span>
          <mat-menu #joinerSummaryMenu="matMenu" yPosition="below" style="margin-top: 2% !important;">
              <app-select-filter-option [values]="joinerSelectValues[i]" [source]="tab.nodeName" [emptyColumns]="joinerSelectEmptyColumns[i]" [selectedColumns]="joinerSelectFilterValues[i]" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
          </mat-menu>
          <app-preview-table style="width: 100px;" [delegate]="this" #joinerSummaryPreviewTable [hideRefresh]="true" previewType="Summary"
              [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"></app-preview-table>
      </mat-tab>
      <mat-tab label="Summary (Output)">
          <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryoutput" #menuTriggerOutput="matMenuTrigger"  style="margin-top: 3px;margin-left: 5px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerOutput,'Output')">Summary Fields</button>
          <span>{{ totalSummaryRowsOutput }}</span>
          <mat-menu #menusummaryoutput="matMenu" yPosition="below" style="margin-top: 2% !important;">
              <app-select-filter-option [values]="selectValuesOutput" source="Output" [emptyColumns]="selectEmptyColumnsOutput" [selectedColumns]="selectFilterValuesOutput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
          </mat-menu>
          <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableOutput [hideRefresh]="true" previewType="Summary" 
              [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
      </mat-tab>
  </mat-tab-group>

  </mat-expansion-panel>
</mat-accordion>

<mat-accordion>
  <mat-expansion-panel (opened)="refineryListpanelOpenState = true" (closed)="refineryListpanelOpenState = false" [expanded]="refineryListpanelOpenState">
    <mat-expansion-panel-header *ngIf="refineryListpanelOpenState">
      <mat-panel-description>
         <p [ngStyle]="{'color':dataPreviewNodeColor, 'font-size': '17px'}" >Refinery List</p> 
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="content">
      <mat-card>
        <!-- <mat-card-header>
              <mat-icon class="card-header-icon" mat-card-avatar>builds</mat-icon>
              <mat-card-title>Refinery</mat-card-title>
              <mat-card-subtitle>List of data Refinery</mat-card-subtitle>
          </mat-card-header> -->
        <!-- <mat-card-actions style="margin-left: 0px; margin-bottom: 10px;">
              <button mat-flat-button style="margin-bottom: 10px;" color="primary" title="Add New Refinery">
                  <mat-icon>note_add</mat-icon>
                  <span style="margin-left: 10px;">New Refinery</span>
              </button>
          </mat-card-actions> -->
        <mat-card-content style="margin:0px 10px !important;padding-top: 0px !important; position: relative; min-height: 80px;">
          <div style="margin-bottom: 5px;">
            <button type="button" mat-stroked-button color="primary" (click)="loadRefineryConfigs()" [disabled]="isLoadingRefineryConfigs" title="Refresh the list and check status">
              <mat-icon>refresh</mat-icon>
              <span style="margin-left: 5px;">Refresh</span>
            </button>
          </div>
          <div class="loading-overlay" *ngIf="isLoadingRefineryConfigs">
            <mat-progress-spinner diameter="50" mode="indeterminate" color="primary"></mat-progress-spinner>
            <div class="loading-text">Loading refineries...</div>
          </div>
          <h1 *ngIf="!isLoadingRefineryConfigs && (!hasConfigs || hasError)" class="center" style="color: lightgray">{{ hasError ? 'Failed to Load
            Refineries' : 'No Refineries Found' }}</h1>
<div class="table-scroll">
          <table *ngIf="hasConfigs" mat-table [dataSource]="mappingConfigs" class="mat-elevation-z8"style="width:max-content; min-width:1500px; background:red;" >
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef> Id </th>
              <td mat-cell *matCellDef="let config"> {{config.id}} </td>
            </ng-container>
    
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef> Name </th>
              <td mat-cell *matCellDef="let config"> {{config.name}} </td>
            </ng-container>
            <ng-container matColumnDef="owner">
              <th mat-header-cell *matHeaderCellDef> Owner </th>
              <td mat-cell *matCellDef="let config"> {{config.owner}} </td>
            </ng-container>
            <ng-container matColumnDef="createdDateTime">
              <th mat-header-cell *matHeaderCellDef> Created Date </th>
              <td mat-cell *matCellDef="let config"> {{datePipe.transform(config.createdDateTime, 'MM/dd/yyyy h:mm:ss a')}}
              </td>
            </ng-container>
    
            <ng-container matColumnDef="modifiedDateTime">
              <th mat-header-cell *matHeaderCellDef> Modified Date </th>
              <td mat-cell *matCellDef="let config"> {{datePipe.transform(config.modifiedDateTime, 'MM/dd/yyyy h:mm:ss a')}}
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> Status </th>
              <td mat-cell *matCellDef="let config"> {{RefineryStatusUtil.toString(config.status)}} </td>
            </ng-container>
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef> Description </th>
              <td mat-cell *matCellDef="let config"> {{config.description}} </td>
            </ng-container>
            <ng-container matColumnDef="shared">
      <th mat-header-cell *matHeaderCellDef> Shared </th>
      <td mat-cell *matCellDef="let config">
        <span matTooltipClass="custom-mat-tooltip" style="margin-right: 10px;">
      <mat-slide-toggle color="primary" 
                       labelPosition="before" 
                       [(ngModel)]="config.shared" 
                       (click)="$event.stopPropagation();"
                       (change)="onToggleChange($event.checked, config)"
                       [disabled]="config.owner !== currentUser">
                       
      </mat-slide-toggle>
    </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="public">
      <th mat-header-cell *matHeaderCellDef> Public </th>
      <td mat-cell *matCellDef="let config">
        <span matTooltipClass="custom-mat-tooltip" style="margin-right: 10px;">
      <mat-slide-toggle color="primary" 
                       labelPosition="before" 
                       [(ngModel)]="config.publicShared" 
                       (click)="$event.stopPropagation();"
                       (change)="onPublicToggleChange($event.checked, config)"
                       [disabled]="config.owner !== currentUser">
                       
      </mat-slide-toggle>
    </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="busy">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let config">
        <span *ngIf="isRefineryRunning(config)" class="refinery-running" matTooltipClass="custom-mat-tooltip"
              matTooltip="A run is in progress for this refinery"
              [style.color]="NodeRunStatusUtil.statusColor(NodeRunStatus.Processing)">Running</span>
        <span *ngIf="isRefineryBusy(config)" matTooltipClass="custom-mat-tooltip"
              [matTooltip]="'Currently being edited by ' + getRefineryBusyUserName(config)">
          <mat-icon class="red-icon" style="vertical-align: middle;font-size: 22px !important;">lock</mat-icon>
          {{ getRefineryBusyUserName(config) }}
        </span>
      </td>
    </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef> Actions </th>
              <td mat-cell *matCellDef="let config">
                <button mat-icon-button (click)="$event.stopPropagation(); duplicateConfig(config)">
                  <mat-icon color="primary" class="icon" matTooltip="Duplicate Refinery">content_copy</mat-icon>
                </button>
                <button mat-icon-button (click)="$event.stopPropagation(); deleteConfig(config)"
                [disabled]="config.owner !== currentUser">
                  <mat-icon [ngClass]="config.owner !== currentUser ? 'grey-icon' : 'red-icon'"  matTooltip="Delete Refinery">delete_forever</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row style="cursor: pointer;" *matRowDef="let config; columns: displayedColumns;"
              (click)="onRefineryRowClicked(config)"></tr>
          </table>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-expansion-panel>
</mat-accordion>
<div class="topmenuparent">
  <div class="refinerynamestyl">
    <span style="font-size: 20px; padding-left: 18px;  font-weight: regular; color: white;">Refinery: {{viewModel.dataRefineryConfig.name}} </span>
    <span *ngIf="isReadOnly" matTooltipClass="custom-mat-tooltip"
          matTooltip="You can view nodes, configuration, and output, but changes require Edit mode."
          style="margin-left: 12px; padding: 2px 10px; border-radius: 10px; background: #5a2d2d; color: #f2c2c2; font-size: 12px; font-weight: 600; letter-spacing: .04em;">
      <mat-icon style="vertical-align: middle; font-size: 16px; height: 16px; width: 16px;">visibility</mat-icon>
      READ-ONLY
    </span>
  </div>
  <div class="submenustyl">

    <!-- <button mat-flat-button style="margin-bottom: 10px;" color="primary" title="Add New Refinery"
    (click)="NewRefineryConfig()">
    <mat-icon>note_add</mat-icon>
    <span style="margin-left: 10px;">New Refinery</span>
    </button>     -->


    <button style="color: #098be2" mat-button  [matMenuTriggerFor]="createingest" #ingestMenuTrigger="matMenuTrigger" [disabled]="isRunInProgress">
      <!-- Create ingest button -->
    <!--<svg width="90px" height="45px" mat-button [matMenuTriggerFor]="createingest" style="margin-left: 10px;">
      
       <polygon points="0 0, 60 0, 80 12, 80 40, 0,40"
        style="fill: transparent; fill-opacity: 0.5; stroke: #0fbdd4;stroke-width: 2;" />
      <foreignObject alignment-baseline="central" [attr.x]="12" [attr.y]="0" width="45px" height="40px">
        <a style="font-weight: 950;font-size: 65px;" title="ADD INGEST">+</a>
      </foreignObject> -->
      <!-- <title>ADD INGEST</title> 
    </svg> -->
    <img src="../assets/images/AddIngest.png" width="45" />
    <span style="margin-top: 50px;">ADD INGEST</span>
    </button>
  
    <button style="color: #1ea9d3" mat-button class="open-btn" (click)="onClickOpenButton()">
      <img src="../assets/images/document_fileup_uploadicon.png" width="25" />OPEN...
    </button>

    <button style="color: #1ea9d3" mat-button (click)="NewRefineryConfig(ingestMenuTrigger)">
      <img src="../assets/images/NewRefinery.png" width="40" />NEW
    </button>
  
    <button style="color: #1ea9d3" mat-button (click)="saveRefineryConfig()" [disabled]="isReadOnly || isRunInProgress">
      <mat-icon class="primary-color-icon" >save</mat-icon>SAVE
    </button>

    <button style="color: #1ea9d3" mat-button (click)="runRefineryConfig()" [disabled]="isReadOnly || isRunInProgress">
      <mat-icon class="green-icon primary-color-icon" >play_arrow</mat-icon>RUN
    </button>

    <span *ngIf="isRunInProgress" class="run-in-progress" [style.color]="NodeRunStatusUtil.statusColor(NodeRunStatus.Processing)">
      <mat-spinner diameter="18" class="run-in-progress-spinner"></mat-spinner>{{ runInProgressLabel }}
    </span>
    <button *ngIf="refineryRun && refineryRun.jobId && !refineryRun.cancelling" mat-button class="run-cancel-btn"
            (click)="cancelRefineryRun()" matTooltip="Stop the run after the node currently running">
      <mat-icon>stop_circle</mat-icon>CANCEL
    </button>

    <button style="color: #1ea9d3" mat-button (click)="resetRefineryConfig()" [disabled]="isReadOnly || isRunInProgress">
      <mat-icon class="gray-icon primary-color-icon" >autorenew</mat-icon>RESET
    </button>
  
    <button style="color: #1ea9d3" mat-button (click)="onClickExportButton()" [disabled]="isRunInProgress">
      <img src="../assets/images/exporticon.png" height="25" style=" filter: brightness(0) invert(1);"/>EXPORT
    </button>

    <button style="color: #1ea9d3" mat-button (click)="onClickImportButton()" [disabled]="isRunInProgress">
      <mat-icon class="primary-color-icon">file_upload</mat-icon>IMPORT
    </button>

    <a mat-button href="https://evidant.com/wp-content/uploads/DTR/About/DTR_Menu.pdf#view=FitW" target="_blank">
     <mat-icon class="help-blue-icon" style="margin-right: 5px;">
  help_outline
</mat-icon>About...
    </a>

  </div>
</div>
<div class="ngxgraph" [ngStyle]="{'width.px': graphWidth, 'height.px': graphHeight}">
  <!-- Create the canvas ngx-graph [view]="[1000, 2500]"-->
  <ngx-graph [update$]="update$" class="chart-container" [links]="filterlinks" [view]="[graphWidth, graphHeight]"
    [nodes]="viewModel.dataRefineryConfig.nodes" (select)="onNodeSelect($event)" [draggingEnabled]="false"
    [curve]="curve" [enableZoom]="false" [autoZoom]="false" [layout]="layout" [layoutSettings]="layoutSettings"
    [nodeWidth]="viewModel.nodeWidth" [nodeHeight]="viewModel.nodeHeight" [panningEnabled]="false" #ngxgraph (window:resize)="onResize($event)">
    <ng-template #defsTemplate>
      <svg:marker id="0" viewBox="0 -5 10 10" refX="10" refY="0" markerWidth="4" markerHeight="4" orient="auto">
        <svg:path d="M0,-5L10,0L0,5" class="arrow-head path" />
      </svg:marker>
      <svg:marker [attr.id]="colorp.id" viewBox="0 -5 10 10" refX="10" refY="0" markerWidth="4" markerHeight="4"
        orient="auto" *ngFor="let colorp of colorPallet">
        <svg:path d="M0,-5L10,0L0,5" [attr.stroke]="colorp.hexCode" [attr.fill]="colorp.hexCode" />
      </svg:marker>

      <svg:marker [attr.id]="Primarycolor.id" viewBox="0 -5 10 10" refX="10" refY="0" markerWidth="4" markerHeight="4"
        orient="auto" *ngFor="let Primarycolor of PrimarycolorPallet">
        <svg:path d="M0,-5L10,0L0,5" [attr.stroke]="Primarycolor.hexCode" [attr.fill]="Primarycolor.hexCode" />
      </svg:marker>
    </ng-template>

    <!-- Node create - Create the Refinery node box on the UI-->
    <ng-template #nodeTemplate let-node>
      <svg:g class="node" ngx-tooltip
        (mouseenter)="showGearIcon($event,node.data.x,node.data.y,node.id,node.data.farmtypeid)"
        (mouseleave)="hideGearIcon($event)">
        <svg:polygon  [attr.points]="NodeBoxShape(node.data.nodeboxtypeid).points"
          [attr.style]="NodeBoxColor(node.data.farmtypeid)" />

        <!-- Title Box -->
        <foreignObject alignment-baseline="central" [attr.x]="NodeBoxShape(node.data.nodeboxtypeid).Title_X"
          [attr.y]="NodeBoxShape(node.data.nodeboxtypeid).Title_Y" [attr.width]="viewModel.nodeWidth-50" height="50px"
          (dblclick)="editTitle(node.id)"
          >
          <span *ngIf="!node.data.isEditTitle"     [id]="'et' + node.id"
            [ngStyle]="{'font-size':viewModel.nodeFontSizeTitle+'px'}" >
             {{node.label}} 
            <!-- {{node.data.rowNo}} : {{node.data.colNo}}-->
            </span>
          <input *ngIf="node.data.isEditTitle" [ngStyle]="{'font-size':viewModel.nodeFontSizeTitle+'px'}" matInput
            required [(ngModel)]="node.label"      [ngClass]="{ 'highlight-blue': node.data.isHighlightBlue }"
             value="{{node.label}}" 
             (keydown.enter)="RenameTitle(node.id,$event)"
            (focusout)="RenameTitle(node.id,$event)" 
            (keydown.Tab)="RenameTitle(node.id,$event)"
              (keydown)="handleEditKeydown($event, node)"
               (mousedown)="onInputMouseDown(node, $event)"
             
            placeholder="Enter {{GetNodeBoxName(node.data.nodeboxtypeid)}} Name" [id]="idCreatForTitle(node.id)">
        </foreignObject>

        <!-- Sub-Title Box -->
        <foreignObject alignment-baseline="central" [attr.x]="NodeBoxShape(node.data.nodeboxtypeid).SubTitle_X"
          [attr.y]="NodeBoxShape(node.data.nodeboxtypeid).SubTitle_Y" [attr.width]="viewModel.nodeWidth-50"
          height="50px" style="line-height: 1;padding-top: 7px;">
          <span 
            [ngStyle]="{'font-size':viewModel.nodeFontSizeSubtitle+'px'}">{{node.data.subtitle}}</span>
          
        </foreignObject>

        <!-- Node ID Descriptor-->
        <foreignObject alignment-baseline="central" [attr.x]="NodeBoxShape(node.data.nodeboxtypeid).nodeId_X" 
          [attr.y]="NodeBoxShape(node.data.nodeboxtypeid).nodeId_Y"
          [attr.width]="viewModel.nodeWidth-50" height="50px">
          <span
            [ngStyle]="{'font-weight': 'normal','font-size':viewModel.nodeFontSizeFarmType+'px','color':FarmTypeColor(node.data.farmtypeid)+''}">{{node.data.Descriptor}}</span>
        </foreignObject>

        <!-- Status Box Icon -->
        <foreignObject alignment-baseline="central" [attr.x]="NodeBoxShape(node.data.nodeboxtypeid).Status_X"
          [attr.y]="NodeBoxShape(node.data.nodeboxtypeid).Status_Y" [attr.width]="NodeBoxShape(node.data.nodeboxtypeid).Status_Width"
          height="30px">
          <span #blinkingText [ngClass]="{'blinking-text': node.data.nodeStatus === 'Next'}" [ngStyle]="{'float': 'right','font-weight': 'normal', 'color': NodeRunStatusUtil.statusColor(node.data.nodeStatus),'font-size':viewModel.nodeFontSizeStatus+'px'}">
            {{ NodeRunStatusUtil.toString(node.data.nodeStatus) }}
          </span>
        </foreignObject>

        <!-- GearBox Icon -->
        <svg [attr.height]="viewModel.nodeGearSizePX" [attr.width]="viewModel.nodeGearSizePX"
          style="opacity: 0; enable-background:new 0 0 512 512;" [attr.x]="NodeBoxShape(node.data.nodeboxtypeid).Gear_X"
          [attr.y]="NodeBoxShape(node.data.nodeboxtypeid).Gear_Y" [matMenuTriggerFor]="nodemenu"
          #menuTrigger="matMenuTrigger" (mouseenter)="openMenu(node.id,node.data.farmtypeid,menuTrigger)" fill="#6A6A6A"
          version="1.1" id="Layer_1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">

          <path
            d="M424.5,216.5h-15.2c-12.4,0-22.8-10.7-22.8-23.4c0-6.4,2.7-12.2,7.5-16.5l9.8-9.6c9.7-9.6,9.7-25.3,0-34.9l-22.3-22.1  c-4.4-4.4-10.9-7-17.5-7c-6.6,0-13,2.6-17.5,7l-9.4,9.4c-4.5,5-10.5,7.7-17,7.7c-12.8,0-23.5-10.4-23.5-22.7V89.1  c0-13.5-10.9-25.1-24.5-25.1h-30.4c-13.6,0-24.4,11.5-24.4,25.1v15.2c0,12.3-10.7,22.7-23.5,22.7c-6.4,0-12.3-2.7-16.6-7.4l-9.7-9.6  c-4.4-4.5-10.9-7-17.5-7s-13,2.6-17.5,7L110,132c-9.6,9.6-9.6,25.3,0,34.8l9.4,9.4c5,4.5,7.8,10.5,7.8,16.9  c0,12.8-10.4,23.4-22.8,23.4H89.2c-13.7,0-25.2,10.7-25.2,24.3V256v15.2c0,13.5,11.5,24.3,25.2,24.3h15.2  c12.4,0,22.8,10.7,22.8,23.4c0,6.4-2.8,12.4-7.8,16.9l-9.4,9.3c-9.6,9.6-9.6,25.3,0,34.8l22.3,22.2c4.4,4.5,10.9,7,17.5,7  c6.6,0,13-2.6,17.5-7l9.7-9.6c4.2-4.7,10.2-7.4,16.6-7.4c12.8,0,23.5,10.4,23.5,22.7v15.2c0,13.5,10.8,25.1,24.5,25.1h30.4  c13.6,0,24.4-11.5,24.4-25.1v-15.2c0-12.3,10.7-22.7,23.5-22.7c6.4,0,12.4,2.8,17,7.7l9.4,9.4c4.5,4.4,10.9,7,17.5,7  c6.6,0,13-2.6,17.5-7l22.3-22.2c9.6-9.6,9.6-25.3,0-34.9l-9.8-9.6c-4.8-4.3-7.5-10.2-7.5-16.5c0-12.8,10.4-23.4,22.8-23.4h15.2  c13.6,0,23.3-10.7,23.3-24.3V256v-15.2C447.8,227.2,438.1,216.5,424.5,216.5z M336.8,256L336.8,256c0,44.1-35.7,80-80,80  c-44.3,0-80-35.9-80-80l0,0l0,0c0-44.1,35.7-80,80-80C301.1,176,336.8,211.9,336.8,256L336.8,256z" />
        </svg>
      </svg:g>

      <!-- Excel Icon for Database writer -->
      <!-- <svg *ngIf=" node.data.dbWriterType == 'Excel' " xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" [attr.x]="NodeBoxShape(node.data.nodeboxtypeid).DataWriter_X"
        [attr.y]="NodeBoxShape(node.data.nodeboxtypeid).DataWriter_Y" viewBox="0,0,256,256"
        [attr.height]="viewModel.DatawriterSizePX" [attr.width]="viewModel.DatawriterSizePX" fill-rule="nonzero">
        <g fill-opacity="0.01176" fill="#dddddd" fill-rule="nonzero" stroke="none" stroke-width="1"
          stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
          font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
          <path d="M0,256v-256h256v256z" id="bgRectangle"></path>
        </g>
        <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter"
          stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none"
          font-size="none" text-anchor="none" style="mix-blend-mode: normal">
          <g transform="scale(5.33333,5.33333)">
            <path d="M29,6h-13.256c-0.963,0 -1.744,0.781 -1.744,1.744v7.259h15z" fill="#169154"></path>
            <path d="M14,33.054v7.202c0,0.963 0.781,1.744 1.743,1.744h13.257v-8.946z" fill="#18482a"></path>
            <path d="M14,15.003h15v9.002h-15z" fill="#0c8045"></path>
            <path d="M14,24.005h15v9.05h-15z" fill="#17472a"></path>
            <g>
              <path d="M42.256,6h-13.256v9.003h15v-7.259c0,-0.963 -0.781,-1.744 -1.744,-1.744z" fill="#29c27f"></path>
              <path d="M29,33.054v8.946h13.257c0.962,0 1.743,-0.781 1.743,-1.743v-7.202h-15z" fill="#27663f"></path>
              <path d="M29,15.003h15v9.002h-15z" fill="#19ac65"></path>
              <path d="M29,24.005h15v9.05h-15z" fill="#129652"></path>
            </g>
            <path
              d="M22.319,34h-16.638c-0.928,0 -1.681,-0.753 -1.681,-1.681v-16.638c0,-0.928 0.753,-1.681 1.681,-1.681h16.638c0.928,0 1.681,0.753 1.681,1.681v16.638c0,0.928 -0.753,1.681 -1.681,1.681z"
              fill="#0c7238"></path>
            <path
              d="M9.807,19h2.386l1.936,3.754l2.046,-3.754h2.229l-3.071,5l3.141,5h-2.351l-2.11,-3.93l-2.101,3.93h-2.386l3.193,-5.018z"
              fill="#ffffff"></path>
          </g>
        </g>
      </svg> -->
      <!-- <span [ngStyle]="{'font-weight': 'normal','font-size':viewModel.nodeFontSizeStatus+'px'}">DW =
        {{NodeBoxShape(node.data.nodeboxtypeid).DataWriter_X +','+
        NodeBoxShape(node.data.nodeboxtypeid).DataWriter_X}}</span> -->

      <!-- File Icon for Database writer -->
      <!-- <svg *ngIf=" node.data.isdbupdater && node.data.dbWriterType != 'database' " xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256" [attr.height]="viewModel.DatawriterSizePX"
        [attr.width]="viewModel.DatawriterSizePX" fill-rule="nonzero"
        [attr.x]="NodeBoxShape(node.data.nodeboxtypeid).DataWriter_X"
        [attr.y]="NodeBoxShape(node.data.nodeboxtypeid).DataWriter_Y">
        <g fill="#FFFFFF" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
          stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none"
          font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
          <g transform="scale(10.66667,10.66667)">
            <path [attr.fill]="NodeRunStatusUtil.statusColor(node.data.dataWriterStatus)"
              d="M6,2c-1.09425,0 -2,0.90575 -2,2v16c0,1.09426 0.90575,2 2,2h12c1.09426,0 2,-0.90574 2,-2v-12l-6,-6zM6,4h7v5h5v11h-12z">
            </path>
          </g>
        </g>
      </svg> -->

      <!-- DB Icon for Database writer && node.data.dbWriterType == 'database' 
      <svg (click)="dataWriterRunMsg(9)" *ngIf=" node.data.isdbupdater  " xmlns="http://www.w3.org/2000/svg"
        [attr.height]="viewModel.DatawriterSizePX" [attr.width]="viewModel.DatawriterSizePX" viewBox="0 0 24 24"
        [attr.x]="NodeBoxShape(node.data.nodeboxtypeid).DataWriter_X"
        [attr.y]="NodeBoxShape(node.data.nodeboxtypeid).DataWriter_Y">
        <path fill="none" d="M0,0H24V24H0Z" data-name="Path 3684" />
        <path [attr.fill]="NodeRunStatusUtil.statusColor(node.data.dataWriterStatus)"
          d="M9.6,0C4.3,0,0,1.88,0,4.2V15c0,2.32,4.3,4.2,9.6,4.2s9.6-1.88,9.6-4.2V4.2C19.2,1.88,14.9,0,9.6,0ZM3.533,2.879A15.864,15.864,0,0,1,9.6,1.8a15.864,15.864,0,0,1,6.067,1.079C16.989,3.458,17.4,4.05,17.4,4.2s-.411.742-1.733,1.321A15.864,15.864,0,0,1,9.6,6.6,15.864,15.864,0,0,1,3.533,5.521C2.211,4.942,1.8,4.35,1.8,4.2S2.211,3.458,3.533,2.879ZM15.667,16.321A15.864,15.864,0,0,1,9.6,17.4a15.864,15.864,0,0,1-6.067-1.079C2.211,15.742,1.8,15.15,1.8,15V12.047A15.748,15.748,0,0,0,9.6,13.8a15.748,15.748,0,0,0,7.8-1.753V15C17.4,15.15,16.989,15.742,15.667,16.321Zm0-5.4A15.864,15.864,0,0,1,9.6,12a15.864,15.864,0,0,1-6.067-1.079C2.211,10.342,1.8,9.75,1.8,9.6V6.647A15.748,15.748,0,0,0,9.6,8.4a15.748,15.748,0,0,0,7.8-1.753V9.6C17.4,9.75,16.989,10.342,15.667,10.921Z"
          data-name="Path 2608" transform="translate(2.4 2.4)" />
      </svg>-->

      <foreignObject
        *ngIf="node.data.isdbupdater"
        [attr.x]="NodeBoxShape(node.data.nodeboxtypeid).DataWriter_X"
        [attr.y]="NodeBoxShape(node.data.nodeboxtypeid).DataWriter_Y"
        [attr.width]="30"
        [attr.height]="30">

        <div xmlns="http://www.w3.org/1999/xhtml">
          <ng-container *ngIf="getIconImageSrcByStatus(node.data.dbWriterType, node.data.dataWriterStatus); else cssWriterIcon">
            <img (click)="dataWriterRunMsg(9)"
                 [src]="getIconImageSrcByStatus(node.data.dbWriterType, node.data.dataWriterStatus)"
                 style="cursor:pointer;"
                 [style.width.px]="viewModel.dataWriterSizePX"
                 [style.height.px]="viewModel.dataWriterSizePX" />
          </ng-container>
          <ng-template #cssWriterIcon>
            <i
              (click)="dataWriterRunMsg(9)"
              style="cursor: pointer;"
              [ngClass]="[getIconClass(node.data.dbWriterType)]"
              [ngStyle]="{
                'font-size.px': viewModel.dataWriterSizePX,
                'color': NodeRunStatusUtil.statusColor(node.data.dataWriterStatus)
              }"></i>
          </ng-template>
        </div>

      </foreignObject>
    </ng-template>

    <!-- link create - Create the data pipes on the UI -->

    <ng-template #linkTemplate let-link>
      <svg:g class="edge">
        <svg:path class="line" *ngIf="link.data.linetype === 'line'" stroke-width="2"
          [attr.marker-end]="ArrowColor(link.data.linkcolorno)"
          [attr.stroke]="getColorfromPrimaryPallet(link.data.linkcolorno)?.hexCode">
          <title>{{ linehOverText(link.id) }}</title>
        </svg:path>

        <svg:path
          class="line"
          *ngIf="link.data.linetype === 'doubleline'"
          stroke-width="2"
          [attr.marker-end]="ArrowColor(link.data.linkcolorno)"
          [attr.stroke]="getColorfromPrimaryPallet(link.data.linkcolorno)?.hexCode"
          [attr.d]="link.path"> 
          <title>{{ linehOverText(link.id) }}</title>
        </svg:path>

        <svg:path
          class="line dotted"
          *ngIf="link.data.linetype === 'doubleline'"
          stroke-width="2"
          [attr.marker-end]="ArrowColor(link.data.linkcolorno)"
          [attr.stroke]="getColorfromPrimaryPallet(link.data.linkcolorno)?.hexCode"
          [attr.d]="getlinkpath(link.points)">
          <title>{{ linehOverText(link.id) }}</title>
        </svg:path>
        
        
        <svg:path class="line dotted" *ngIf="link.data.linetype === 'dotted'" stroke-width="2"
          [attr.marker-end]="ArrowColor(link.data.linkcolorno)"
          [attr.stroke]="getColorfromPrimaryPallet(link.data.linkcolorno)?.hexCode">
          <title>{{ linehOverText(link.id) }}</title>
        </svg:path>

        <svg:path class="line" *ngIf="link.data.linetype === 'joiner'" stroke-width="2"
          [attr.marker-end]="ArrowColor(link.data.linkcolorno)"
          [attr.stroke]="getColorfromPrimaryPallet(link.data.linkcolorno)?.hexCode">
          <title>{{ linehOverText(link.id) }}</title>
        </svg:path>

        
      </svg:g>
    </ng-template>
  </ngx-graph>
</div>
<!-- This is the dropdown menu comming when clicking the Gear icon <span (mouseleave)="closeMenu()"-->
<mat-menu #nodemenu="matMenu" [overlapTrigger]="false" (closed)="closeMenu($event)">
  <span (mouseenter)="showGearIconOver()" (click)="hideGearIconOver()">
    <!-- Read-Only: only Open Node and About This Node stay enabled — every
         other item here is a mutation (or a shortcut to one), so all of
         them are disabled via isReadOnly rather than each relying on the
         click handler's own warnAndBlockIfRefineryBusy() gate. Viewing a
         node's configuration/output goes through Open Node, which stays
         available. -->
    <button mat-menu-item (click)="openNode()"><span [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Open Node</span></button>
    <button mat-menu-item (click)="runNode()" [disabled]="isReadOnly"><span [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Run Node</span></button>
    <button mat-menu-item (click)="ResetNode()" [disabled]="isReadOnly"><span [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Reset Node</span></button>
    <button mat-menu-item (click)="toggleTransformerView()"    [disabled]="!isTransformerTypeEnabled() || isReadOnly"><span [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}" > {{ transformerToggleLabels[id] || 'Show Transformer Type' }}</span></button>
    <button mat-menu-item [disabled]="UndoConfigDisabled || isReadOnly" (click)="UndoConfig()"><span [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Undo {{undoConfigEvent}}</span></button>
    <button mat-menu-item (click)="createProcessor(2)" [disabled]="isReadOnly"><span [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Add Processor</span></button>
    <button mat-menu-item (click)="insertNode(2)" [disabled]="InsertProcessorDisabled || isReadOnly"><span [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Insert Processor (before)</span></button>
    <button mat-menu-item [disabled]="NewJoinerMenuDisabled || isReadOnly" (click)="createProcessor(3)"><span [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Add Joiner</span></button>
    <button mat-menu-item [disabled]="InsertJoinerDisabled || isReadOnly" (click)="insertNode(3)"><span [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Insert Joiner (after)</span></button>
    <button mat-menu-item [disabled]="JoinerMenuDisabled || isReadOnly" [matMenuTriggerFor]="joiner"><span
        [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Add to Existing Joiner</span></button>
    <button mat-menu-item [disabled]="ExistingJoinerMenuDisabled || isReadOnly" [matMenuTriggerFor]="DeleteJoiner"><span
        [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Delete Joiner to</span>
      </button>
    <button mat-menu-item [disabled]="FConverterMenuDisabled || isReadOnly" (click)="createProcessor(4)"><span
        [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Add Farm Converter</span></button>
    <!-- <button mat-menu-item (click)="addDatabaseUpdater()" [disabled]="!disableremovedbupdaterpmenu">Add Database Updater</button>
        <button mat-menu-item (click)="removeDatabaseUpdater()" [disabled]="disableremovedbupdaterpmenu">Remove Database Updater</button> -->
    <button mat-menu-item [disabled]="AddLookUpDisabled || isReadOnly" [matMenuTriggerFor]="addlookup"><span
        [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Add Attribution to</span></button>
    <button mat-menu-item [matMenuTriggerFor]="deletelookup" [disabled]="disabledeletelookupmenu || isReadOnly"><span
        [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Delete Attribution to</span></button>

    <button mat-menu-item (click)="removeNode()" [disabled]="RemoveNodeDisabled || isReadOnly"><span
      [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Remove Node</span></button>
    <button mat-menu-item (click)="deleteNodeChildren()" [disabled]="isReadOnly"><span
      [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Delete Node & Children</span></button>
    <button mat-menu-item (click)="dataPreviewNode($event)" [disabled]="isReadOnly"><span
      [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Data Preview</span></button>

       <button mat-menu-item (click)="renameNode()" [disabled]="isReadOnly"><span
      [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">Rename Node</span></button>
    <button mat-menu-item (click)="openAboutThisNode()"><span
      [ngStyle]="{'font-size':viewModel.menuFontSizePX+'px'}">About This Node</span></button>
        </span>
</mat-menu>

<!-- Submenu for - Add to Existing Joiner -->
<mat-menu #joiner="matMenu">
  <button mat-menu-item *ngFor="let item of JoinerNodeArr" (click)="createJoiner(item.id)">
    <span [ngStyle]="{'color': FarmTypeColor(item.data.farmtypeid), 'font-size': viewModel.menuFontSizePX + 'px'}">{{ item.data.Descriptor }}</span>
  </button>
</mat-menu>

<!-- Submenu for - Delete Joiner to -->
<mat-menu #DeleteJoiner="matMenu">
  <button mat-menu-item *ngFor="let item of ExistingJoinerArr" (click)="deleteJoiner(item.id)">
    <span [ngStyle]="{'color': FarmTypeColor(item.data.farmtypeid), 'font-size': viewModel.menuFontSizePX + 'px'}">{{ item.data.Descriptor }}</span>
  </button>
</mat-menu>

<!-- Submenu for - Add Lookup to -->
<mat-menu #addlookup="matMenu">
  <button mat-menu-item *ngFor="let item of LookUpNodeArr" (click)="addLookup(item.id)">
    <span [ngStyle]="{'color': FarmTypeColor(item.data.farmtypeid), 'font-size': viewModel.menuFontSizePX + 'px'}">{{ item.data.Descriptor }}</span>
  </button>
</mat-menu>

<!-- Submenu for - Delete Lookup to -->
<mat-menu #deletelookup="matMenu">
  <button mat-menu-item *ngFor="let item of deletelookupnode" (click)="deleteLookup(item.id)">
    <span [ngStyle]="{'color': FarmTypeColor(item.data.farmtypeid), 'font-size': viewModel.menuFontSizePX + 'px'}">{{ item.data.Descriptor }}</span>
  </button>
</mat-menu>

<!-- show all the farmtypes in dropdown menu when click the creat ingest button  -->
<mat-menu #createingest="matMenu">
  <button mat-menu-item *ngFor="let item of farmtype" (click)="createIngest(item.id,item.farmtype,item.nodeboxtypeid)">
    <span [style.color]="item.color"> {{ item.farmtype }}</span></button>
</mat-menu>
